export type SafeUrlArgs = TmplStringArgs<
    URLSearchParams | string | undefined | null
>;
export function safeUrl(...[strParts, ...args]: SafeUrlArgs): string {
    if (typeof strParts == 'string') {
        throw new Error(
            'This is a template function, please use `` as function'
        );
    }
    let result = strParts[0];
    let i = 0;
    while (i < args.length) {
        const arg = args[i];

        const part =
            arg === null || arg === undefined
                ? ''
                : typeof arg === 'string'
                  ? encodeURIComponent(arg)
                  : arg.toString();
        result += part + strParts[++i];
    }
    return result;
}
